/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { memo, useEffect, useLayoutEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "usehooks-ts";
import { Box, Button, Column, Columns, Stack } from "@origin-digital/ods-core";
import { navigation } from "@origin-digital/reporting-client";
import { abortPreviousRequestsIfAny, getSessionIdUrlKey } from "@/abort";
import { Screen, StyledHeading, StyledText } from "@/components";
import { appName } from "@/config";
import { TTL, TTL_KEY } from "@/constants";
import { SolarForm } from "@/features/SolarForm";
import { useSession } from "@/features/SolarForm/useSession";
import { createPayload, formatLabel } from "@/utils";
import { AccessTime } from "@mui/icons-material";
import GettingStartImage from "@/assets/getting_start_image.svg";
import { gettingStart } from "./content.json";
import { IconHome, IconSme } from "@origin-digital/ods-icons";
import { useMediaQuery, useTheme } from "@mui/material";

export const GettingStartPage = memo(() => {
  const navigate = useNavigate();
  const [_, setTTL] = useLocalStorage(TTL_KEY, TTL);

  const { createSessionId } = useSession();
  const theme = useTheme();
  const isMdDown = useMediaQuery(theme.breakpoints.down("md")); // Check the viewport width is below md = 768px

  useLayoutEffect(() => {
    setTTL(TTL);
  }, []);

  useEffect(() => {
    navigation("screen", {
      appName,
      currentUri: window.location.href,
    });
  });

  const startFormForMyself = () => {
    const defaultValue = {
      ...SolarForm.defaultValue,
      customerType: "myself",
    };
    startForm(defaultValue);
  };

  const startFormForBusiness = () => {
    const defaultValue = {
      ...SolarForm.defaultValue,
      customerType: "",
    };
    startForm(defaultValue);
  };

  const startForm = async (defaultValue: any) => {
    const result = await createSessionId();
    if (result.sessionId) {
      navigate("/form/contact-detail", {
        state: { ...createPayload(defaultValue) },
      });
    }
  };

  useEffect(() => {
    // clean up
    return () => {
      abortPreviousRequestsIfAny(getSessionIdUrlKey());
    };
  }, []);

  return (
    <Screen id={gettingStart.id}>
      <>
        <GettingStartImage />
        <StyledHeading>{gettingStart.heading}</StyledHeading>
        <StyledText>{gettingStart.description}</StyledText>
        <Box marginTop="large">
          <Columns space="small">
            <Column width="content" alignX="center">
              <AccessTime />
            </Column>
            <Column>
              <StyledHeading variant="h3" tone="neutralDark">
                {formatLabel(
                  gettingStart.timeNeedToSpend.label,
                  (value) => value,
                  "2 to 10 minutes"
                )}
              </StyledHeading>
            </Column>
          </Columns>
        </Box>
        <>
          <StyledText>{gettingStart.requiredAssets.label}</StyledText>
        </>
        <Box marginY="xlarge">
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            marginTop="small"
          >
            <Stack space={"medium"} alignX="left">
              <Button
                muiProps={{ startIcon: <IconHome color="white" /> }}
                onClick={startFormForMyself}
                fullWidth={isMdDown ?? true}
                data-id={gettingStart.startButton.home.id}
              >
                {gettingStart.startButton.home.label}
              </Button>
              <Button
                color="secondaryB"
                muiProps={{ startIcon: <IconSme color="white" /> }}
                onClick={startFormForBusiness}
                fullWidth={isMdDown ?? true}
                data-id={gettingStart.startButton.business.id}
              >
                {gettingStart.startButton.business.label}
              </Button>
            </Stack>
          </Box>
        </Box>
      </>
    </Screen>
  );
});
